import React from 'react';
import { useDispatch } from 'react-redux';
import API from '../../utils/api';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Fetchs3image from '../../utils/fetchs3image';
import { useNavigate, useParams } from 'react-router-dom';
import { setLocation } from '../../redux/actions/locationActions';
import { useSelector } from 'react-redux';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl:    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl:  'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});


const EditPlace =() => {
    const { id } = useParams(); 
    const [loading, setLoading] = useState(true)
    const [coords,setCoords] = useState({latitude:null,longitude:null})
    const [usebox , setusebox] = useState(true)
    const [placeimages, setplaceimages] = useState([])
    const [temp,setTemp] = useState(null);
    const location = useSelector((state) => state.location.location);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [place, setPlace] = useState({
      });

      const [query, setQuery] = useState('');
      const [debouncedQuery, setDebouncedQuery] = useState('');
      const [results, setResults] = useState([]);


      const handleChange = (e) => {
        const { name, value } = e.target;
      
        setPlace(prev => ({
          ...prev,
          [name]: value
        }));
      };
      useEffect(() => {
        const fetchPlace = async () => {
          try {
            const data = await axios({
                method:"POST",
                url:"https://api.heytout.com/places/list/" + id
            })
            const p = data.data.rows[0]
            setPlace(p);
            var latlng = JSON.parse(p.geojson).coordinates;
            const latitude = latlng[0];
            const longitude = latlng[1];

            setCoords({
              latitude:latitude,
              longitude:longitude
            })
          } catch (err) {
            console.log('failed to load place')
          } finally {
            setLoading(false);
          }
        };
    
        fetchPlace();
      }, [id]);

      useEffect(()=>{
        const fetchplaceimages = async() => {
          try {
            const data = await axios({
              method:"GET",
              url:"https://api.heytout.com/places/placeimages/" + id
          })

          console.log("PLACE IMAGES",data)
          setplaceimages(data.data)
          } catch(error) {
            console.log('failed to load place images')
          }
        }
        fetchplaceimages();
      },[id])
      const updateplacerecord = async() => {
        try {
            const data = {
                id:id,
                name:place.name,
                tagline:place.tagline,
                description:place.description,
                latitude:coords.latitude,
                longitude:coords.longitude,
                phone:place.phone
            }
            var res = await axios({
                method:'POST',
                url:'https://api.heytout.com/places/update',
                data: {
                    name:data.name,
                    tagline:data.tagline,
                    description:data.description,
                    latitude:data.latitude,
                    longitude:data.longitude,
                    phone:data.phone,
                    id:data.id
                }
    
            })
        } catch(error) {
            console.log('NO NO NO ',error)
        }

      }
      const fetchplaceimages = async() => {
        try {
          const data = await axios({
            method:"GET",
            url:"https://api.heytout.com/places/placeimages/" + id
        })

        console.log("PLACE IMAGES",data)
        setplaceimages(data.data)
        } catch(error) {
          console.log('failed to load place images')
        }
      }
      const handleDragEnd = (e) => {
        const newPos = e.target.getLatLng();
        setCoords({latitude:newPos.lat, longitude:newPos.lng});
        onLocationChange(newPos.lat, newPos.lng);
      };

      const onLocationChange = (lat,lng) => {
      }

  // 1. Debounce input by 800ms
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // 2. Call API when debouncedQuery changes
  useEffect(() => {
    if (!debouncedQuery) {
      setResults([]);
      return;
    }

    // Example fetch — replace with your actual API call
    const fetchCities = async () => {
        try {
          const res = await axios({
            method:'POST',
            url:'https://api.heytout.com/geo/searchforaddress',
            data: {
                search:debouncedQuery,
                latitude:coords.latitude,
                longitude:coords.longitude,
                bbox:usebox
            }
          })
          const data = res;
          setResults(data.data.features);
        } catch (err) {
          console.error('Error fetching cities:', err);
        }
      };
  
      fetchCities();
    }, [debouncedQuery]);

    const handleUploadImage = async(e) => {
      try {
        const fileobj = e.target.files[0];
        console.log('FILE OBJECT',fileobj)
        var photo = await API.uploadimage({
          file:fileobj
        })
        console.log('THE NEW PHOTO URI!!!',photo)
        const key = photo;
        const bucket = 'toutimage';
        const placeid = id;
        const imageurl = Fetchs3image({
          bucket:bucket,
          key:key,
          width:500
        })
        var newimage = await axios({
          method:'post',
          url:'https://api.heytout.com/image/addimagetoplace',
          data : {
            placeid:placeid,
            key:key,
            bucket:bucket,
            imageurl:imageurl
          }
        })
        console.log('THE NEW IMAGE',newimage)
        fetchplaceimages();
      } catch(error) {
        console.log('error in react function uploading',error)
      }
    }

    const deletePlace = async () => {
      try {
        const data = await axios({
            method:"POST",
            url:"https://api.heytout.com/places/delete/",
            data: {
              id:id
            }
        })
      } catch (err) {
        console.log('failed to delte place')
      } finally {
        navigate('/')
      }
    };
    console.log('placeimages',placeimages)
    return loading ? null : (
        <div className="tcontainer">
            <div className="trow">
                <div className="tcol">
                    <div className="tinputwrap">
                        <div className="tinputlabel">Name</div>
                        <input
                        className="tinput"
                        name="name"
                        value={place.name}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                        <div className="tinputlabel">Tagline (short description)</div>
                        <input
                        className="tinput"
                        name="tagline"
                        value={place.tagline}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                        <div className="tinputlabel">Description</div>
                        <textarea className="ttextarea"
                            value={place.description}
                            name="description"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                        <div className="tinputlabel">Phone</div>
                        <input
                        className="tinput"
                        name="phone"
                        value={place.phone}
                        onChange={handleChange}
                        />
                    </div>

                    <div className="tinputwrap">
                <button
                    onClick={updateplacerecord}
                >update place record</button>

                    </div>
                    <div className="placeimageswrap">
                    {placeimages.map(p=>{
                      console.log('image',p)
                      var url = Fetchs3image({
                        bucket:p.bucket,
                        key:p.key,
                        width:400
                      })
                      console.log('image url',url)
                      return (
                        <div className="placeimage" style={{
                          backgroundImage:`url(${url})`,
                          backgroundSize:'cover',
                          backgroundPosition:'center'
                        }}>
                          <button
                            onClick={()=>{
                              console.log(p.id)
                              axios({
                                method:'POST',
                                url:'https://api.heytout.com/image/delete',
                                data: {
                                  id:p.id
                                }
                              }).then(d=>{
                                console.log('success',d);
                                fetchplaceimages();
                              }).catch(error=>{
                                console.log('error deleteing',error)
                              })
                            }}
                          >delete</button>
                        </div>
                      )
                    })}
                    <div className="placeimageholder">
                      <div className="placeimageholderinside">
                      <input type="file" accept="image/*" onChange={handleUploadImage} />

                      </div>
                    </div>

                      </div>
                      <div>
                        <button style={{background:'red',marginTop:20}} onClick={deletePlace}>delete this place</button>
                      </div>
                </div>
                <div className="tcol">
                <MapContainer center={[coords.latitude,coords.longitude]} zoom={23} style={{ height: '400px', width: '100%' }}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org">OpenStreetMap</a>'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                        position={[coords.latitude,coords.longitude]}
                        draggable={true}
                        eventHandlers={{ dragend: handleDragEnd }}
                    />
                    </MapContainer>
                    <div className="trow">
                <div className="tcol vmiddle">
                    <input
                        type="text"
                        placeholder="Search city..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        className="tinput"
                        />
                    </div>
                    <input type="checkbox"
                      checked={usebox}
                      onChange={(e)=>{
                        setusebox(e.target.checked)
                      }}
                    />
                </div>
                            {results.length > 0 &&
                                <div className="row">
                                    {results.map(r=>{
                                        return (
                                            <div onClick={()=>{
                                              setCoords({longitude:r.center[0],latitude:r.center[1]})
                                              setResults([])

                                            }} className="placename">{r.place_name}</div>
                                        )
                                    })}
                                </div>
                            }
                </div>
            </div>
        </div>
    )
}

export default EditPlace;
